// extracted by mini-css-extract-plugin
export default {"map":"Map_map__jbav3","ol-control":"Map_ol-control__6MonM","ol-full-screen":"Map_ol-full-screen__fy8FJ"};